// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { StateModel } from "@insite/client-framework/Types/ApiModels";

const getProvinces = (): StateModel[] => {
    // Canada provinces are hardcoded because Canada is not a transactional country assigned to the website
    return [
        { name: translate("Alberta"), abbreviation: "AB", id: "AB", uri: "", properties: {} },
        { name: translate("Manitoba"), abbreviation: "MB", id: "MB", uri: "", properties: {} },
        { name: translate("British Columbia"), abbreviation: "BC", id: "BC", uri: "", properties: {} },
        { name: translate("New Brunswick"), abbreviation: "NB", id: "NB", uri: "", properties: {} },
        { name: translate("Newfoundland"), abbreviation: "NL", id: "NL", uri: "", properties: {} },
        { name: translate("Nova Scotia"), abbreviation: "NS", id: "NS", uri: "", properties: {} },
        { name: translate("Northwest Territories"), abbreviation: "NT", id: "NT", uri: "", properties: {} },
        { name: translate("Nunavut"), abbreviation: "NU", id: "NU", uri: "", properties: {} },
        { name: translate("Ontario"), abbreviation: "ON", id: "ON", uri: "", properties: {} },
        { name: translate("Prince Edward Island"), abbreviation: "PE", id: "PE", uri: "", properties: {} },
        { name: translate("Quebec"), abbreviation: "QC", id: "QC", uri: "", properties: {} },
        { name: translate("Saskatchewan"), abbreviation: "SK", id: "SK", uri: "", properties: {} },
        { name: translate("Yukon Territory"), abbreviation: "YT", id: "YT", uri: "", properties: {} },
    ];
};

export default getProvinces;
